<template>
  <el-tabs type="border-card" v-model="activeName" stretch>
    <el-tab-pane label="基本信息" name="jbxx">
      <el-form
        ref="form1"
        :model="form1"
        :rules="form1Rules"
        label-width="80px"
      >
        <el-row>
          <el-col :lg="12" :xs="24">
            <el-form-item label="单位名称" prop="dw_name">
              <el-input v-model="form1.dw_name"></el-input>
            </el-form-item>
          </el-col>
          <!-- <el-col :lg="12" :xs="24">
            <el-form-item label="单位类别" prop="user_type2">
              <el-select
                v-model="form1.user_type2"
                placeholder="请选择"
                style="width: 100%"
              >
                <el-option
                  v-for="item in optionsDict.unitMemberClass"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col> -->
          <el-col :lg="12" :xs="24">
            <el-form-item label="网址" prop="web_url">
              <el-input v-model="form1.web_url"></el-input>
            </el-form-item>
          </el-col>
          <el-col :lg="12" :xs="24">
            <el-form-item label="所在地区" prop="area">
              <el-cascader
                style="width: 100%"
                v-if="hasLoadArea"
                v-model="form1.area"
                :options="areaOptions"
                :props="areaProps"
              ></el-cascader>
            </el-form-item>
          </el-col>
          <el-col :lg="12" :xs="24">
            <el-form-item label="具体地址" prop="address">
              <el-input v-model="form1.address"></el-input>
            </el-form-item>
          </el-col>
          <el-col :lg="12" :xs="24">
            <el-form-item label="单位性质" prop="property">
              <el-select
                v-model="form1.property"
                placeholder="请选择"
                style="width: 100%"
              >
                <el-option
                  v-for="item in optionsDict.unitProperty"
                  :key="item.id"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="单位简介" prop="introduction">
              <Toolbar
                style="border-bottom: 1px solid #ccc"
                :editor="editor"
                :defaultConfig="toolbarConfig"
                :mode="mode"
              />
              <Editor
                style="height: 500px; overflow-y: hidden"
                v-model="form1.introduction"
                :defaultConfig="editorConfig"
                :mode="mode"
                @onCreated="onCreated"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="register-btn-center">
        <el-button type="warning" @click="jbxxSubmit()">下一步</el-button>
      </div>
    </el-tab-pane>
    <el-tab-pane label="联系方式" name="lxfs">
      <el-form
        ref="form2"
        :model="form2"
        :rules="form2Rules"
        label-width="80px"
      >
        <el-row>
          <el-col :lg="12" :xs="24">
            <el-form-item label="联系人" prop="contact">
              <el-input v-model="form2.contact"></el-input>
            </el-form-item>
          </el-col>
          <el-col :lg="12" :xs="24">
            <el-form-item label="所在部门" prop="department">
              <el-input v-model="form2.department"></el-input>
            </el-form-item>
          </el-col>
          <el-col :lg="12" :xs="24">
            <el-form-item label="职务" prop="job">
              <el-input v-model="form2.job"></el-input>
            </el-form-item>
          </el-col>
          <el-col :lg="12" :xs="24">
            <el-form-item label="办公电话" prop="office_phone">
              <el-input v-model="form2.office_phone"></el-input>
            </el-form-item>
          </el-col>
          <el-col :lg="12" :xs="24">
            <el-form-item label="手机" prop="phone">
              <el-input v-model="form2.phone"></el-input>
            </el-form-item>
          </el-col>
          <el-col :lg="12" :xs="24">
            <el-form-item label="电子邮箱" prop="email">
              <el-input v-model="form2.email"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="register-btn-center">
        <el-button type="warning" @click="lxfsSubmit()">下一步</el-button>
      </div>
    </el-tab-pane>
    <el-tab-pane label="负责人信息" name="frxx">
      <el-form
        ref="form3"
        :model="form3"
        :rules="form3Rules"
        label-width="80px"
      >
        <el-row>
          <el-col :lg="12" :xs="24">
            <el-form-item label="姓名" prop="fr_name">
              <el-input v-model="form3.fr_name"></el-input>
            </el-form-item>
          </el-col>
          <el-col :lg="12" :xs="24">
            <el-form-item label="性别" prop="fr_sex">
              <el-select
                v-model="form3.fr_sex"
                placeholder="请选择"
                style="width: 100%"
              >
                <el-option
                  v-for="item in optionsDict.gender"
                  :key="item.id"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="12" :xs="24">
            <el-form-item label="民族" prop="fr_national">
              <el-select
                v-model="form3.fr_national"
                placeholder="请选择"
                style="width: 100%"
              >
                <el-option
                  v-for="item in optionsDict.nation"
                  :key="item.id"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="12" :xs="24">
            <el-form-item label="籍贯" prop="fr_birthplace">
              <el-cascader
                style="width: 100%"
                v-if="hasLoadBirthplace"
                v-model="form3.fr_birthplace"
                :options="areaOptions"
                :props="birthplaceProps"
              ></el-cascader>
            </el-form-item>
          </el-col>
          <el-col :lg="12" :xs="24">
            <el-form-item label="出生日期" prop="fr_birthday">
              <el-date-picker
                v-model="form3.fr_birthday"
                type="date"
                format="yyyy 年 MM 月 dd 日"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
                style="width: 100%"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :lg="12" :xs="24">
            <el-form-item label="政治面貌" prop="fr_political">
              <el-select
                v-model="form3.fr_political"
                placeholder="请选择"
                style="width: 100%"
              >
                <el-option
                  v-for="item in optionsDict.political"
                  :key="item.id"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="12" :xs="24">
            <el-form-item label="学历" prop="fr_education">
              <el-select
                v-model="form3.fr_education"
                placeholder="请选择"
                style="width: 100%"
              >
                <el-option
                  v-for="item in optionsDict.education"
                  :key="item.id"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="12" :xs="24">
            <el-form-item label="办公电话" prop="fr_office_phone">
              <el-input v-model="form3.fr_office_phone"></el-input>
            </el-form-item>
          </el-col>
          <el-col :lg="12" :xs="24">
            <el-form-item label="手机" prop="fr_phone">
              <el-input v-model="form3.fr_phone"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="register-btn-center">
        <el-button type="warning" @click="frxxSubmit()">提交</el-button>
      </div>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import { request } from "@/api/service";
import cookies from "@/libs/util.cookies";
import { Editor, Toolbar } from "@wangeditor/editor-for-vue";

export default {
  components: { Editor, Toolbar },
  data() {
    return {
      activeName: "jbxx",
      optionsDict: {},
      areaOptions: null,
      hasLoadArea: false,
      hasLoadBirthplace: false,
      areaProps: {
        lazy: true,
        lazyLoad(node, resolve) {
          let url = "/api/system/getArea?limit=999&page=1&level=1";
          if (node && node.value) {
            url = "/api/system/getArea?limit=999&pcode=" + node.value;
          }
          request({
            url: url,
            method: "get",
          }).then((response) => {
            const nodes = response.data.data.map((item) => ({
              value: item.code,
              label: item.name,
              leaf: item.level > 2,
            }));
            resolve(nodes);
          });
        },
      },
      birthplaceProps: {
        lazy: true,
        lazyLoad(node, resolve) {
          let url = "/api/system/getArea?limit=999&page=1&level=1";
          if (node && node.value) {
            url = "/api/system/getArea?limit=999&pcode=" + node.value;
          }
          request({
            url: url,
            method: "get",
          }).then((response) => {
            const nodes = response.data.data.map((item) => ({
              value: item.code,
              label: item.name,
              leaf: item.level >= 2,
            }));
            resolve(nodes);
          });
        },
      },
      form1: {
        dw_name: "",
        user_type2: "",
        web_url: "",
        area: [],
        address: "",
        property: "",
        introduction: "",
      },
      form1Rules: {
        dw_name: [
          { required: true, message: "请输入单位名称", trigger: "blur" },
        ],
        area: [{ required: false, message: "请选择", trigger: "blur" }],
        web_url: [{ required: false, message: "请输入网址", trigger: "blur" }],
        address: [{ required: false, message: "请输入地址", trigger: "blur" }],
        property: [{ required: false, message: "请输入性质", trigger: "blur" }],
        introduction: [],
      },
      form2: {
        contact: "",
        department: "",
        job: "",
        office_phone: "",
        phone: "",
        email: "",
      },
      form2Rules: {
        contact: [{ required: false, message: "请输入", trigger: "blur" }],
        department: [{ required: false, message: "请输入", trigger: "blur" }],
        job: [{ required: false, message: "请输入", trigger: "blur" }],
        office_phone: [{ required: false, message: "请输入", trigger: "blur" }],
        phone: [{ required: false, message: "请输入", trigger: "blur" }],
        email: [{ required: false, message: "请输入", trigger: "blur" }],
      },
      form3: {
        fr_name: "",
        fr_sex: "",
        fr_national: "",
        fr_birthplace: "",
        fr_birthday: "1970-01-01",
        fr_political: "",
        fr_education: "",
        fr_office_phone: "",
        fr_phone: "",
      },
      form3Rules: {
        fr_name: [{ required: false, message: "请输入", trigger: "blur" }],
        fr_sex: [{ required: false, message: "请输入", trigger: "blur" }],
        fr_national: [{ required: false, message: "请输入", trigger: "blur" }],
        fr_birthplace: [{ required: false, message: "请输入", trigger: "blur" }],
        fr_birthday: [{ required: false, message: "请输入", trigger: "blur" }],
        fr_political: [{ required: false, message: "请输入", trigger: "blur" }],
        fr_education: [{ required: false, message: "请输入", trigger: "blur" }],
        fr_office_phone: [
          { required: false, message: "请输入", trigger: "blur" },
        ],
        fr_phone: [{ required: false, message: "请输入", trigger: "blur" }],
      },
      editor: null,
      toolbarConfig: {
        toolbarKeys: [
          "blockquote",
          "header1",
          "header2",
          "header3",
          "|",
          "bold",
          "underline",
          "italic",
          "through",
          "color",
          "bgColor",
          "clearStyle",
          "|",
          "bulletedList",
          "numberedList",
          "todo",
          "justifyLeft",
          "justifyRight",
          "justifyCenter",
          "|",
          "insertLink",
          {
            key: "group-image",
            title: "图片",
            iconSvg:
              '<svg viewBox="0 0 1024 1024"><path d="M959.877 128l0.123 0.123v767.775l-0.123 0.122H64.102l-0.122-0.122V128.123l0.122-0.123h895.775zM960 64H64C28.795 64 0 92.795 0 128v768c0 35.205 28.795 64 64 64h896c35.205 0 64-28.795 64-64V128c0-35.205-28.795-64-64-64zM832 288.01c0 53.023-42.988 96.01-96.01 96.01s-96.01-42.987-96.01-96.01S682.967 192 735.99 192 832 234.988 832 288.01zM896 832H128V704l224.01-384 256 320h64l224.01-192z"></path></svg>',
            menuKeys: ["insertImage"],
          },
          "insertVideo",
          "insertTable",
          "codeBlock",
          "|",
          "undo",
          "redo",
          "|",
          "fullScreen",
        ],
      },
      editorConfig: { placeholder: "请输入内容..." },
      mode: "simple", // or 'default'
      dialogVisible: false,
      fileList: [],
    };
  },
  mounted() {
    this.getUserInfoFun();
    this.getDictFun();
    this.refreshUI();
  },
  beforeDestroy() {
    const editor = this.editor;
    if (editor == null) return;
    editor.destroy(); // 组件销毁时，及时销毁编辑器
  },
  methods: {
    refreshUI() {
      this.$nextTick(() => {
        var self = this;
        this.areaProps.lazyLoad(null, (children) => {
          self.hasLoadArea = true;
        });
        this.birthplaceProps.lazyLoad(null, (children) => {
          self.hasLoadBirthplace = true;
        });
      });
    },
    getUserInfoFun() {
      var self = this;
      request({
        url: "/app/getUserInfo",
        method: "post",
        data: {
          user_type: "单位会员",
        },
      }).then((res) => {
        if (res.code == 2000) {
          for (const key in self.form1) {
            if (res.data[key]) {
              self.form1[key] = res.data[key];
            }
          }
          for (const key in self.form2) {
            if (res.data[key]) {
              self.form2[key] = res.data[key];
            }
          }
          for (const key in self.form3) {
            if (res.data[key]) {
              self.form3[key] = res.data[key];
            }
          }

          self.form3.fr_sex = res.data.fr_sex + "";
          self.form1.area = res.data.area ? JSON.parse(res.data.area) : [];
          self.form3.fr_birthplace = res.data.fr_birthplace
            ? JSON.parse(res.data.fr_birthplace)
            : [];
          self.refreshUI();
        }
      });
    },
    onCreated(editor) {
      this.editor = Object.seal(editor); // 一定要用 Object.seal() ，否则会报错
    },
    getDictFun() {
      var self = this;
      request({
        url: "/app/getDictionary",
        method: "post",
        data: {
          keys: [
            "gender", // 性别
            "nation", // 民族
            "education", // 学历
            "political", // 政治面貌
            "identification", // 身份证件
            "technical", // 技术职称
            "beGoodAtFields", // 擅长领域

            "unitProperty", // 单位性质
            "unitMemberClass", // 单位会员类别
          ],
        },
      }).then((res) => {
        self.optionsDict = res.data;
        console.log(self.optionsDict.membershipCategory);
      });
    },
    jbxxSubmit() {
      this.$refs.form1.validate((valid) => {
        if (valid) {
          this.activeName = "lxfs";
          console.log(this.form1);
        }
      });
    },
    lxfsSubmit() {
      this.$refs.form2.validate((valid) => {
        if (valid) {
          this.activeName = "frxx";
          console.log(this.form2);
          this.refreshUI();
        }
      });
    },
    frxxSubmit() {
      this.$refs.form3.validate((valid) => {
        if (valid) {
          let user_type = cookies.get("user_type");
          var self = this;
          request({
            url: "/app/updateUserInfo",
            method: "post",
            data: {
              ...this.form1,
              ...this.form2,
              ...this.form3,
              user_type: user_type,

              area: JSON.stringify(this.form1.area),
              fr_birthplace: JSON.stringify(this.form3.fr_birthplace),
            },
          }).then((res) => {
            if (res.code == 2000) {
              this.$message({
                message: "提交成功",
                type: "success",
              });

              cookies.set("name", self.form1.dw_name);
              window.location.reload();
            } else {
              this.$message({
                message: res.msg,
                type: "error",
              });
            }
          });
        }
      });
    },
  },
};
</script>

<style src="@wangeditor/editor/dist/css/style.css"></style>

<style lang="scss" scoped>
.register-btn-center {
  margin: 40px auto;
  display: grid;
  place-items: center;
}
.tag-box {
  margin: 0 20px 20px 0;
}
</style>